import { authFetch, BASE_BACKEND_URL } from '../../../auth'
import { useCallback } from 'react'


const buildStoreRelationPayload = ({
  formState,
  isEditMode,
  relationId,
  canSplitOrderByBrand,
  principalResolutionContext
}) => {
  const payload = {
    supplier_id: formState?.supplierOption?.value || formState?.supplierOption?.id || null,
    buyer_id: formState?.buyerOption?.value || formState?.buyerOption?.id || null,
    store_reference: formState?.referenceOption?.value || formState?.referenceOption?.label || null,
    client_db_ref: formState?.clientOption?.db_ref || null,
    principal_salesman_db_ref: formState?.principalUserOption?.db_ref || null
  }

  if (canSplitOrderByBrand) {
    payload.allow_brand_assignments = Boolean(formState?.shouldAssignUsersByBrand)
    payload.client_brand_relations = Boolean(formState?.shouldAssignUsersByBrand)
      ? (formState?.assignmentRows || []).map((row) => ({
        salesman_db_ref: row?.salesmanDbRef || null,
        brand_db_refs: (row?.brandOptions || [])
          .map((brand) => brand?.db_ref)
          .filter(Boolean)
      }))
      : []
  }

  if (isEditMode && relationId) {
    payload.store_relation_id = relationId
  }

  if (principalResolutionContext) {
    payload.principal_resolution_context = principalResolutionContext
  }

  return payload
}

const useSaveStoreRelation = () => {
  const saveStoreRelation = useCallback(async ({
    formState,
    isEditMode,
    relationId,
    canSplitOrderByBrand,
    principalResolutionContext
  }) => {
    const payload = buildStoreRelationPayload({
      formState,
      isEditMode,
      relationId,
      canSplitOrderByBrand,
      principalResolutionContext
    })

    console.info('Store relation payload to backend', {
      mode: isEditMode ? 'edit' : 'create',
      splitOrderByBrandEnabled: Boolean(canSplitOrderByBrand),
      splitOrderByBrandChecked: Boolean(formState?.shouldAssignUsersByBrand),
      payload
    })

    console.info('Store relation request preview', {
      action: isEditMode ? 'PATCH existing relation' : 'POST new relation',
      relationId: relationId || null,
      payload,
      isEditMode
    })

    if (principalResolutionContext) {
      console.info('Store relation reassign user payload preview', {
        endpoint_intent: isEditMode
          ? 'PATCH /poc/store_relations_overview/:id'
          : 'POST /poc/store_relations_overview',
        relationId: relationId || null,
        payload
      })
    }

    const shouldUpdate = Boolean(isEditMode && relationId)
    const endpoint = shouldUpdate
      ? `${BASE_BACKEND_URL}/poc/store_relations_overview/${relationId}`
      : `${BASE_BACKEND_URL}/poc/store_relations_overview`

    const response = await authFetch(endpoint, {
      method: shouldUpdate ? 'PATCH' : 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })

        if (!response) return null

    const responseBody = await response.json().catch(() => ({
      errors: [`HTTP error ${response.status}`]
    }))

    if (response.ok) {
      return responseBody
    }

    if (response.status === 422 && responseBody?.flow?.mode === 'edit' && responseBody?.result) {
      return responseBody
    }

    const error = new Error(
      responseBody?.errors?.join(' | ') ||
      responseBody?.error ||
      `HTTP error ${response.status}`
    )

    error.status = response.status
    error.response = responseBody || {
      errors: [error.message]
    }

    throw error
  }, [])

  return {
    saveStoreRelation
  }
}

export default useSaveStoreRelation
